'use client'

import GoogleTagManager from '@/components/GoogleTagManager/GoogleTagManager'
import Loading from '@/components/Loading/Loading'
import styles from '@/styles/main.scss'

import axios from '@/utils/axiosInterceptor'
import Script from 'next/script'
import { useEffect, useState } from 'react'

import Hubspot from '@/components/Hubspot/HubspotChat'

export default function RootLayout({ children }) {
    const [loggedIn, setLoggedIn] = useState(null)

    useEffect(() => {
        const checkLoggedIn = async () => {
            try {
                const { data } = await axios.get(`/assessment/api/auth/getId`)
                if (data.success) {
                    window.location.assign(`/`)
                }
                setLoggedIn(data.success)
            } catch (e) {
                setLoggedIn(false)
            }
        }

        checkLoggedIn()
    }, [])

    return (
        <>
            <title>Taxd - Login</title>
            <Script
                src={`https://www.google.com/recaptcha/api.js?render=${process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}`}
                strategy="afterInteractive"
            />
            <link rel="icon" href="/favicon.png" type="image/png" sizes="16x16" />
            <Hubspot />
            <GoogleTagManager />
            {loggedIn == false && children}
            <Loading visible={loggedIn || loggedIn == null} />
        </>
    )
}
